import type { FAQSection } from "@/modules/corporate/types/sections"
import type { FunctionComponent } from "react"

import { clsx } from "clsx"
import Image from "next/image"
import { useState } from "react"

import ArrowDown from "@jobteaser/ui-kit/assets/icons/jds_arrowDown.svg"
import { Icon, ICON_SIZES } from "@jobteaser/ui-kit/components/Icon/Icon"
import { Layout } from "@jobteaser/ui-kit/components/Layout/Layout"
import { Text, TEXT_TYPES, TEXT_WEIGHTS } from "@jobteaser/ui-kit/components/Text/Text"

import { RichText } from "@/modules/kontent/components/RichText"

import styles from "./FrequentlyAskedQuestions.module.css"

export type FAQPropsType = {
  section: FAQSection
}

export const FrequentlyAskedQuestions: FunctionComponent<FAQPropsType> = ({ section }) => {
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0)

  return (
    <Layout hasBottomPadding hasTopPadding>
      <Layout.Column>
        {!!section.title && (
          <Text
            className={styles.title}
            data-highlighted-word={section.title}
            resetSpacing
            tag="h2"
            type={TEXT_TYPES.HEADING_BIG}
            weight={TEXT_WEIGHTS.BLACK}
          >
            {section.title}
          </Text>
        )}
        {!!section.subtitle && (
          <Text className={styles.subtitle} resetSpacing tag="p" type={TEXT_TYPES.SUBHEAD} weight={TEXT_WEIGHTS.BLACK}>
            {section.subtitle}
          </Text>
        )}
        {!!section.image.length && (
          <div className={styles.wrapperImage}>
            <Image
              alt={section.image[0].description || ""}
              className={styles.image}
              height={section.image[0].height || undefined}
              priority
              src={section.image[0].url}
              width={section.image[0].width || undefined}
            />
          </div>
        )}
      </Layout.Column>
      <Layout.Column>
        {!!section.questions.length && (
          <ul className={styles.list}>
            {section.questions.map(({ answer, question }, index) => (
              <li
                className={clsx(styles.listItem, { [styles["listItem--active"]]: currentQuestionIndex === index })}
                key={question}
              >
                <button
                  className={styles.button}
                  onClick={() => {
                    setCurrentQuestionIndex(index)
                  }}
                  type="button"
                >
                  {question}
                  <Icon className={styles.icon} size={ICON_SIZES.MEDIUM} xlinkHref={`#${ArrowDown.id}`} />
                </button>

                {currentQuestionIndex === index && (
                  <RichText
                    value={answer}
                    wrapperProps={{
                      className: styles.text,
                      resetSpacing: true,
                      tag: "div",
                      type: TEXT_TYPES.SMALL,
                    }}
                  />
                )}
              </li>
            ))}
          </ul>
        )}
      </Layout.Column>
    </Layout>
  )
}
